import { useEffect, useState } from "react";
import { createClient, Session } from "@supabase/supabase-js";
import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { isUserAuthenticated } from "./auth";

const key = process.env.REACT_APP_SUPABASE_KEY;
const project = process.env.REACT_APP_SUPABASE_PROJECT;

const supabaseUrl = `https://${project}.supabase.co`;
const supabaseAnonKey = key!; // use ! if you're sure it's defined, or add a check

const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

type Role = "admin" | "user";

export const useAuth = () => {
  const [session, setSession] = useState<Session | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [role, setRole] = useState<Role | null>(null);
  const [userID, setUserId] = useState<string | null>(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      const role = session?.user.user_metadata.role;
      setRole(role ?? "user");
      const id = session?.user.id;
      setUserId(id ?? null);
      setIsLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      const role = session?.user.user_metadata.role;
      setRole(role ?? "user");
      const id = session?.user.id;
      setUserId(id ?? null);

      // Might be needed to get profile data later on.
      // if (session?.user) {
      //   supabase
      //     .from("profiles")
      //     .select("role")
      //     .eq("id", session.user.id)
      //     .single()
      //     .then(({ data }) => {
      //       setRole(data?.role ?? null);
      //     });
      // }
      setIsLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  const signOut = async () => {
    setRole(null);
    setUserId(null);
    setSession(null);
    await supabase.auth.signOut();
  };

  return {
    session,
    isLoading,
    client: supabase,
    isUserAuthenticated: session !== null,
    signOut,
    role,
    userID,
  };
};
